import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { RewardSchedulesAPI } from '@API/data-services/reward-schedules-service'
import { readErrorMessage } from '@Components/util/utils'
import { RewardScheduleContentUpdateRequest } from '@Generated/back-office-client/src'
import { PRIZE_SCHEDULES_QUERY_KEY } from './types'

const SAVE_FAILED_MESSAGE = 'Could not save the prize schedule.'

// Shared by both edit sidebars: saves, refreshes the list, and closes; a failure keeps the sidebar open with the
// server's message
export const useSaveScheduleContent = (scheduleId: string, onSaved: () => void) => {
  const queryClient = useQueryClient()
  const [saveError, setSaveError] = useState<string | null>(null)

  const mutation = useMutation({
    mutationFn: (update: RewardScheduleContentUpdateRequest) =>
      RewardSchedulesAPI.updateContent(scheduleId, update),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: PRIZE_SCHEDULES_QUERY_KEY })
      onSaved()
    },
    onError: async (error) => setSaveError(await readErrorMessage(error, SAVE_FAILED_MESSAGE)),
  })

  const save = (update: RewardScheduleContentUpdateRequest) => {
    setSaveError(null)
    mutation.mutate(update)
  }

  return { save, saveError, isSaving: mutation.isPending }
}
